import {types} from './types';

const initialState = {
    list: {
        data: [],
        page: 1
    },
    view: {
        
    }
}

export function freespinGameReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_GAME_FREESPIN:
            return { ...state, list: action.payload};
        case types.SET_VIEW_GAME_FREESPIN:
            return { ...state, view: action.payload};
        default:
            return state
    }
}